import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const StoreSearch = lazy(() => import('./pages/StoreSearch'));
const StoreDetail = lazy(() => import('./pages/StoreDetail'));
const AreaDetail = lazy(() => import('./pages/AreaDetail'));
const TestStores = lazy(() => import('./pages/TestStores'));
const TimezoneTools = lazy(() => import('./pages/TimezoneTools'));
const AnalyticsDashboard = lazy(() => import('../analytics/pages/AnalyticsDashboard'));

export const storesRoutes: RouteObject = {
  path: 'stores',
  handle: { breadcrumb: 'Restaurants' },
  children: [
    { index: true, element: <StoreSearch />, handle: { breadcrumb: 'Search' } },
    { path: 'create-test', element: <TestStores />, handle: { breadcrumb: 'Test Restaurants' } },
    { path: 'timezone', element: <TimezoneTools />, handle: { breadcrumb: 'Timezone Tools' } },
    {
      path: 'equipment',
      element: <AnalyticsDashboard />,
      handle: { breadcrumb: 'Equipment & Routines' },
    },
    { path: 'areas/:areaId', element: <AreaDetail />, handle: { breadcrumb: 'Area' } },
    { path: ':champsNumber', element: <StoreDetail />, handle: { breadcrumb: 'Detail' } },
  ],
};
